/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum Feature {
  Classifications = 10,
  CustomFields = 15,
  Adjustments = 20,
  Attachments = 30,
  DraftAssets = 40,
  RevaluationsImpairments = 70,
  Impairments = 75,
  Components = 80,
  Quantities = 90,
  PartialDisposals = 95,
  PremiumIntegration = 110,
  CustomDepreciationMethods = 160,
  BulkActions = 1000,
  ConsolidatedReports = 1010,
}
